import { createSlice } from "@reduxjs/toolkit";
import { PhoneWhitelistState } from "./types";
import {
    fetchEnableWhitelist,
    fetchDisableWhitelist,
    fetchWhitelistedPhones,
    fetchCreateWhitelistEntry,
    fetchDeleteWhitelistEntry,
    fetchBulkCreateWhitelistEntries,
    fetchBulkCreateWhitelistEntriesFromCSV
} from "./phone-whitelist-thunk";
import { ErrorType } from "@/shared/types";

const initialState: PhoneWhitelistState = {
    whitelistedPhones: [],
    isWhitelistedPhonesLoading: false,
    isWhitelistedPhonesFirstLoad: true,
    whitelistedPhonesError: null,
    bulkImportResult: null,
};

const phoneWhitelistSlice = createSlice({
    name: 'phoneWhitelist',
    initialState,
    reducers: {
        clearBulkImportResult: (state) => {
            state.bulkImportResult = null;
        }
    },
    extraReducers(builder) {
        builder
            // Fetch whitelisted phones
            .addCase(fetchWhitelistedPhones.pending, (state) => {
                state.isWhitelistedPhonesLoading = true;
                state.whitelistedPhonesError = null;
            })
            .addCase(fetchWhitelistedPhones.fulfilled, (state, action) => {
                state.isWhitelistedPhonesFirstLoad = false;
                state.isWhitelistedPhonesLoading = false;
                state.whitelistedPhones = action.payload;
                state.whitelistedPhonesError = null;
            })
            .addCase(fetchWhitelistedPhones.rejected, (state, action) => {
                state.whitelistedPhonesError = action.payload as ErrorType;
                state.isWhitelistedPhonesLoading = false;
            })
            // Create whitelist entry
            .addCase(fetchCreateWhitelistEntry.pending, (state) => {
                state.isWhitelistedPhonesLoading = true;
                state.whitelistedPhonesError = null;
            })
            .addCase(fetchCreateWhitelistEntry.fulfilled, (state, action) => {
                state.isWhitelistedPhonesLoading = false;
                state.whitelistedPhones = [...state.whitelistedPhones, action.payload];
                state.whitelistedPhonesError = null;
            })
            .addCase(fetchCreateWhitelistEntry.rejected, (state, action) => {
                state.whitelistedPhonesError = action.payload as ErrorType;
                state.isWhitelistedPhonesLoading = false;
            })
            // Delete whitelist entry
            .addCase(fetchDeleteWhitelistEntry.pending, (state) => {
                state.isWhitelistedPhonesLoading = true;
                state.whitelistedPhonesError = null;
            })
            .addCase(fetchDeleteWhitelistEntry.fulfilled, (state, action) => {
                state.isWhitelistedPhonesLoading = false;
                state.whitelistedPhones = state.whitelistedPhones.filter(
                    phone => phone.id !== action.payload
                );
                state.whitelistedPhonesError = null;
            })
            .addCase(fetchDeleteWhitelistEntry.rejected, (state, action) => {
                state.whitelistedPhonesError = action.payload as ErrorType;
                state.isWhitelistedPhonesLoading = false;
            })
            // Bulk create
            .addCase(fetchBulkCreateWhitelistEntries.pending, (state) => {
                state.isWhitelistedPhonesLoading = true;
                state.whitelistedPhonesError = null;
            })
            .addCase(fetchBulkCreateWhitelistEntries.fulfilled, (state, action) => {
                state.isWhitelistedPhonesLoading = false;
                state.bulkImportResult = action.payload;
                state.whitelistedPhonesError = null;
            })
            .addCase(fetchBulkCreateWhitelistEntries.rejected, (state, action) => {
                state.whitelistedPhonesError = action.payload as ErrorType;
                state.isWhitelistedPhonesLoading = false;
            })
            // Bulk create from CSV
            .addCase(fetchBulkCreateWhitelistEntriesFromCSV.pending, (state) => {
                state.isWhitelistedPhonesLoading = true;
                state.whitelistedPhonesError = null;
            })
            .addCase(fetchBulkCreateWhitelistEntriesFromCSV.fulfilled, (state, action) => {
                state.isWhitelistedPhonesLoading = false;
                state.bulkImportResult = action.payload;
                state.whitelistedPhonesError = null;
            })
            .addCase(fetchBulkCreateWhitelistEntriesFromCSV.rejected, (state, action) => {
                state.whitelistedPhonesError = action.payload as ErrorType;
                state.isWhitelistedPhonesLoading = false;
            });
    },
});

export default phoneWhitelistSlice.reducer;
export const { clearBulkImportResult } = phoneWhitelistSlice.actions;

